import React from 'react';
import { Box, Typography, List, ListItemButton, ListItemText, Button, Avatar } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { StyledSelectedItem } from '../../conf/constants';
import { ProcessFlowsSidebarProps } from '../types/props.types';
import { Flow } from '../types/flow.types';
import { COLORS_CONFIG_PAGE } from '../../conf/constants';

const ProcessFlowsSidebar: React.FC<ProcessFlowsSidebarProps> = ({
  processFlows,
  selectedFlow,
  setSelectedFlow,
  handleDeleteFlow,
  setOpenCreateFlowModal,
}) => {
  return (
    <>
      <Box p={2} sx={{ flexShrink: 0 }}>
        <Typography variant="h6" gutterBottom>Process Flows</Typography>
      </Box>
      <Box sx={{ flexGrow: 1, overflow: 'auto', minHeight: 0 }}>
        <List component="nav" dense>
          {processFlows.map((flow: Flow) => (
            <React.Fragment key={flow.id}>
              {flow.id === selectedFlow ? (
                <StyledSelectedItem onClick={() => setSelectedFlow(flow.id)}>
                  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <Avatar src={`${flow.iconUrl}`} 
                          variant="square"
                          sx={{ mr: 2, bgcolor: 'transparent', width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          maxWidth: '25px', 
                          maxHeight: '25px', }}>
                    </Avatar>
                    <ListItemText primary={flow.name} secondary={flow.description} />
                  </Box>
                </StyledSelectedItem>
              ) : (
                <ListItemButton onClick={() => setSelectedFlow(flow.id)}>
                  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <Avatar src={`${flow.iconUrl}`} variant="square" sx={{ mr: 2, bgcolor: 'transparent',width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          maxWidth: '25px', 
                          maxHeight: '25px', }}>
                    </Avatar>
                    <ListItemText primary={flow.name} secondary={flow.description} />
                  </Box>
                </ListItemButton>
              )}
            </React.Fragment>
          ))}
        </List>
      </Box>
      <Box
        sx={{
          p: 2,
          flexShrink: 0,
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 1,
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpenCreateFlowModal(true)}
          sx={{ bgcolor: COLORS_CONFIG_PAGE.primary, '&:hover': { bgcolor: COLORS_CONFIG_PAGE.primary } }}
        >
          NEW
        </Button>
        <Button
          variant="contained"
          onClick={handleDeleteFlow}
          startIcon={<DeleteIcon />}
          sx={{ bgcolor: COLORS_CONFIG_PAGE.primary, '&:hover': { bgcolor: COLORS_CONFIG_PAGE.primary } }}
        >
          DELETE
        </Button>
      </Box>
    </>
  );
};

export default ProcessFlowsSidebar;